<template>
	<v-dialog v-model="loading"
		persistent
		width="300">
		<v-card color="primary">
			<v-card-text class="background--text">
				Chargement...
				<v-progress-linear
					indeterminate
					color="background"
					class="mb-0">
				</v-progress-linear>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	props: [ 'loading' ]
}
</script>



// WEBPACK FOOTER //
// src/components/loader.vue